import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';

import { MdbModalRef } from 'src/lib/mdb5-adapted/public-api';

import { LmsModalFrameComponent } from '../../ui/lms-modal-frame/lms-modal-frame.component';

@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  template: `
    <app-lms-modal-frame [title]="title" [pageHeadWidth]="450">
      <div modal-body class="container-fluid myh-300 my-2 px-1 text-center">
        <div *ngIf="header" class="my-2">
          <h6>{{header}}</h6>
          <hr class="hr-blurry" />
        </div>
        <h4>{{message}}</h4>
      </div>

      <div modal-actions class="lms-action-bar">
        <button
          *ngIf="!showClose"
          class="btn btn-primary"
          (click)="onDismiss()"
        >
          Cancel
        </button>
        <button
          *ngIf="!showClose"
          class="btn btn-primary"
          (click)="onConfirm()"
        >
          Yes
        </button>
        <button
          *ngIf="showClose"
          class="btn btn-primary"
          (click)="onConfirm()"
        >
          Close
        </button>
      </div>
    </app-lms-modal-frame>
  `,
  styleUrls: ['./confirm-dialog.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  imports: [CommonModule, LmsModalFrameComponent],
})
export class ConfirmDialogComponent implements OnInit {
  title: string;
  header: string;
  message: string;
  showClose: boolean = true;
  isErrorOccured: boolean;

  autoConfirm: boolean;

  constructor(public dialogRef: MdbModalRef<ConfirmDialogComponent>) {
  }
  ngOnInit(): void {
    if (this.autoConfirm) {
      this.dialogRef.close(true);
    }
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onDismiss(): void {
    this.dialogRef.close(false);
  }
}

